import { render, staticRenderFns } from "./InstallmentsDetailsWithProgress.vue?vue&type=template&id=4580981a"
import script from "./InstallmentsDetailsWithProgress.vue?vue&type=script&lang=js"
export * from "./InstallmentsDetailsWithProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports